export default __webpack_public_path__ + "static/media/blue_multi_user.33111c7e.svg";